import { h } from '@stencil/core';
import { iconMap } from './tableCellIconMap';
import { htmlSanitizer } from '@utils/html-sanitizer';
import { setImgAltText } from '@utils/utils';

export interface PrivateStateVars {
  columnDataList: any;
  columnTypeList: any;
  colWidthList: any;
  originalRowData: any;
  scrollbarWidth: any;
  scrollbarThumbWidth: any;
  scrollValue: any;
  docDirFactor: any;
  iconLegendList: any;
  tableSize: [number, number];
}

export const renderTableBody = $this => {
  return $this.hasCellMerges === true ? renderTableBodyContent($this) : <tbody>{renderTableBodyContent($this)}</tbody>;
};

export const stripHTML = htmlStr => {
  if (htmlStr) {
    const dom = new DOMParser().parseFromString(htmlStr, 'text/html');
    return dom.body.textContent;
  }
};

export const handleSort = ($this, columnMetaData, colNum, isSortingOnMounting = false) => {
  const colType = columnMetaData.columnType;
  let sortedData = [...$this.stateObject.originalRowData];

  $this.sortColumn = colNum;
  switch (colType) {
    case 'iconField':
      sortedData = [...$this.stateObject.originalRowData].sort((a, b) => {
        return a[colNum].iconName[0] - b[colNum].iconName[0];
      });
      break;
    case 'textField':
      sortedData = [...$this.stateObject.originalRowData].sort((a, b) => {
        return stripHTML(a[colNum].richText)?.localeCompare(stripHTML(b[colNum].richText), $this.locale, { ignorePunctuation: true });
      });
      break;
    case 'dateField':
      sortedData = [...$this.stateObject.originalRowData].sort((a, b) => {
        return a[colNum].unformattedDate - b[colNum].unformattedDate;
      });
      break;
    default:
      sortedData = [...$this.stateObject.originalRowData];
  }
  if (!isSortingOnMounting) {
    $this.sortDirection = $this.sortDirection === 'asc' ? 'desc' : 'asc';
    applyAriaSort($this, colNum, $this.sortDirection);
  }

  switch ($this.sortDirection) {
    case 'asc':
      $this.rowDataList = sortedData;
      break;
    case 'desc':
      $this.rowDataList = sortedData.reverse();
      break;
    default:
      $this.rowDataList = sortedData;
  }
  return sortedData;
};

export const renderTableColumnGroup = $this => {
  return (
    <colgroup>
      {$this.stateObject.columnDataList.map((_, item) => {
        return <col style={{ width: `${$this.stateObject.colWidthList[item]}%` }} />;
      })}
    </colgroup>
  );
};

export const renderTableHeader = $this => {
  return (
    <thead>
      <tr>
        {$this.stateObject.columnDataList.map((column, item) => {
          return (
            <th
              class={'vs-text vs-col-header ' + (column.enableSort === 'true' ? 'vs-filter-tracker' : 'no')}
              style={{ width: `${$this.stateObject.colWidthList[item]}%` }}
              data-col-type={$this.stateObject.columnTypeList[item]}
              data-col-sortable={column.enableSort === 'true' ? 'yes' : 'no'}
              // START GENAI@GHCOPILOT
              {...setDataSortAttribute($this.stateObject.columnTypeList[item], column.enableSort === 'true')}
              // END GENAI@GHCOPILOT
              onClick={() => {
                column.enableSort === 'true' && !!handleSort($this, column, item);
              }}
              onKeyDown={event => {
                // START GENAI@GHCOPILOT
                // START GENAI@CHATGPT4
              if ((event.key === 'Enter' || event.key === ' ') && column.enableSort === 'true') {
                if (event.key === ' ') {
                  event.preventDefault();  // Prevents the page from scrolling
                }
                handleSort($this, column, item);
              }
              // END GENAI@CHATGPT4
              // END GENAI@GHCOPILOT
              }}
              scope="col"
              tabindex="-1"
            >
              <span
                class="vs-th-container"
                {...(column.enableSort === 'true' ? { role: 'button' } : {})}
                {...setDataSortAttribute($this.stateObject.columnTypeList[item], column.enableSort === 'true')}
              >
                <span
                  class={column.enableSort === 'true' ? 'vs-header-underline' : ''}
                  innerHTML={column.columnHeaderText?.length && htmlSanitizer(column.columnHeaderText)}
                ></span>
                {column.enableSort == 'true' && $this.sortColumn == item && (
                  <span
                    class={`vs-text-icon-sm visa-icon vs-table-sortable-icon ${$this.sortDirection === 'asc' ? 'visa-icon-caret-up-solid' : 'visa-icon-triangle-down-solid-sm'}`}
                    aria-hidden="true"
                  ></span>
                )}
              </span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export const renderTableCaption = $this => {
  return (
    <caption class="vs-sr-only" id={$this.tableId + 'caption'}>
      {$this.tableTitle + ($this.stateObject.columnDataList.length > 4 ? ': ' + $this.tableSummary : '')}
    </caption>
  );
};

//DO NOT DELETE COMMENTED CODE UNLESS EXPORT FULLY TESTED

// export const handleExport = (tableId: number) => {
//   const tableMainElem: HTMLElement = document.querySelector(`[table-id="${tableId}"]`);
//   const exportButtonElement: any = tableMainElem.querySelector(`[data-table-id="${tableId}"]`);
//   const scrollPOS = document.documentElement.scrollTop;
//   window.onbeforeprint = () => {
//     const bodyParentElem = document.createElement('div');
//     bodyParentElem.classList.add('vs-ignore-printing');
//     while (document.body.firstChild) {
//       bodyParentElem.appendChild(document.body.firstChild);
//     }
//     document.body.appendChild(bodyParentElem);

//     const clonedTable: any = tableMainElem.cloneNode(true);
//     const DIV = document.createElement('div');
//     DIV.classList.add('table-printable');
//     clonedTable.style.width = '100%';
//     clonedTable.style.overflow = 'visible';
//     const clonedTableElem = clonedTable.querySelector('table');
//     clonedTableElem.style.overflow = 'visible';
//     clonedTableElem.style.maxWidth = '100%';
//     clonedTableElem.style.width = '100%';
//     clonedTableElem.style.overflowX = 'visible';
//     const tWrapper = clonedTable.querySelector('.vs-table-wrapper');
//     tWrapper.style.maxWidth = '100%';
//     tWrapper.style.overflow = 'visible';

//     DIV.appendChild(clonedTable);
//     document.body.insertBefore(DIV, document.body.children[0]);
//     tableMainElem.scrollIntoView();
//   };
//   window.onafterprint = () => {
//     const clonedTableElem: HTMLElement = document.querySelector(`[class="table-printable"]`);
//     clonedTableElem?.remove();
//     const bodyParentElem: any = document.getElementsByClassName('vs-ignore-printing')[0];
//     bodyParentElem.replaceWith(...bodyParentElem.childNodes);
//     window.scrollTo(0, scrollPOS);
//     exportButtonElement.focus({ preventScroll: true });
//   };
//   window.print();
// };

export const handleExport = (tableId: number) => {
  const getElement = selector => document.querySelector(selector);
  const addClass = (element, className) => element.classList.add(className);
  const removeClass = (element, className) => element.classList.remove(className);
  const mainElem = getElement('main');
  const header = getElement('#vs-navigation-header');
  const footer = getElement('#vs-navigation-footer');
  const tableMainElem: HTMLElement = getElement(`[table-id="${tableId}"]`);
  const exportButtonElement: any = tableMainElem.querySelector(`[data-table-id="${tableId}"]`);

  const modifyStyles = (element, styles) => {
    for (let key in styles) {
      element.style[key] = styles[key];
    }
  };

  window.onbeforeprint = () => {
    addClass(mainElem, 'vs-ignore-printing');
    addClass(header, 'vs-ignore-printing');
    addClass(footer, 'vs-ignore-printing');

    const clonedTable: any = tableMainElem.cloneNode(true);
    const DIV = document.createElement('div');
    addClass(DIV, 'table-printable');
    modifyStyles(clonedTable, { width: '100%', overflow: 'visible' });
    const clonedTableElem = clonedTable.querySelector('table');
    modifyStyles(clonedTableElem, { overflow: 'visible', maxWidth: '100%', width: '100%', overflowX: 'visible' });

    const tWrapper = clonedTable.querySelector('.vs-table-wrapper');
    modifyStyles(tWrapper, { maxWidth: '100%', overflow: 'visible' });
    DIV.appendChild(clonedTable);
    document.body.insertBefore(DIV, mainElem);
  };

  window.onafterprint = () => {
    // START GENAI@COPILOT
    const clonedTableElem: HTMLElement = getElement('.table-printable');
    clonedTableElem?.remove();
    removeClass(mainElem, 'vs-ignore-printing');
    removeClass(header, 'vs-ignore-printing');
    removeClass(footer, 'vs-ignore-printing');
    exportButtonElement.focus({ preventScroll: true });
    // END GENAI@COPILOT
  };

  window.print();
};

export const renderTableExportButton = $this => {
  return (
    <button
      class="vs-table-export-button vs-mb-2 vs-link-cta vs-link-new-window"
      aria-label={$this.exportText + ' (' + $this.exportTextAriaLabel + ')'}
      data-table-id={$this.tableId}
      onClick={() => handleExport($this.tableId)}
      aria-describedby={$this.tableId + 'caption'}
    >
      {$this.exportText}
    </button>
  );
};

export const renderTableScrollBar = $this => {
  return (
    <div class="vs-container-xl" id={'vs-scroll' + $this.tableId}>
      <input
        type="range"
        min="0"
        max={$this.stateObject.scrollbarWidth}
        value="0"
        class="vs-table-scroll vs-mb-3"
        onInput={event => scrollBarBehaviourOnInput(event, $this)}
        onChange={event => scrollBarBehaviourOnChange(event, $this)}
        aria-hidden="true"
        tabindex="-1"
        ref={el => ($this.scrollBarRef = el as HTMLInputElement)}
      ></input>
    </div>
  );
};

export const scrollBarBehaviourOnInput = (e, $this) => {
  let val = e.target.value;
  $this.stateObject.scrollValue = val * $this.stateObject.docDirFactor;
  scrollTable($this, $this.stateObject.scrollValue);
};

export const scrollBarBehaviourOnChange = (e, $this) => {
  let val = e.target.value;
  $this.stateObject.scrollValue = val * $this.stateObject.docDirFactor;
  scrollTable($this, $this.stateObject.scrollValue);
};

export const scrollTable = ($this, val) => {
  $this.tableRef.scroll({
    left: val,
    behavior: 'instant',
  });
};

export const handleTableScroll = $this => {
  $this.scrollBarRef.value = $this.tableRef.scrollLeft * $this.stateObject.docDirFactor;
};

export const setColumnTypes = $this => {
  $this.stateObject.columnTypeList = [...$this.stateObject.columnDataList].map(column => column.columnType);
};

export const setCellData = (cellData, $this) => {
  const colType = cellData.columnType;
  let renderedItem = [];
  switch (colType) {
    case 'textField':
      renderedItem = renderCellText(cellData);
      break;
    case 'imageField':
      renderedItem = renderCellImage(cellData);
      break;
    case 'iconField':
      renderedItem = renderCellIcon(cellData, $this);
      break;
    case 'dateField':
      renderedItem = renderCellDate(cellData);
      break;
    default:
      renderedItem = [''];
  }
  return renderedItem;
};

export const renderCellText = cellData => {
  return (
    <div
      class={cellData.isCenterAligned === 'true' ? 'vs-align-center vs-text richtext' : 'vs-text richtext'}
      innerHTML={cellData.richText?.length && htmlSanitizer(cellData.richText)}
    ></div>
  );
};

export const renderCellDate = cellData => {
  return <div class="vs-align-center vs-text richtext">{cellData.formattedDate}</div>;
};

export const renderCellImage = cellData => {
  return (
    <div class="vs-align-center">
      <img src={cellData.imgPath} alt={setImgAltText(cellData.altText)} class={cellData.imgPath ? 'vs-table-cell-img vs-mb-1' : 'vs-mb-1'} />
      <p class=" vs-text vs-meta vs-my-0 richtext" innerHTML={cellData.descText?.length && htmlSanitizer(cellData.descText)}></p>
    </div>
  );
};

export let renderCellIcon = (cellData, $this) => {
  return (
    cellData &&
    !!Object.keys(cellData).length && (
      <div
        role="img"
        aria-labelledby={$this.tableId + iconMap[cellData?.iconName?.split('#')[1]]?.id}
        class={'vs-align-center vs-primary-text vs-table-icon visa-icon ' + iconMap[cellData.iconName?.split('#')[1]]?.name}
      ></div>
    )
  );
};

export const renderIconLegend = ($this, iconLegend) => {
  return [
    <p class="vs-lead vs-mb-2">{$this.iconKeyText}</p>,
    <p class="vs-mb-2">
      {[...iconLegend].map(iconItem => {
        const iconClass = iconMap[iconItem.iconName.split('#')[1]].name;
        return (
          <span class="vs-table-key-icon">
            <span
              class={'vs-primary-text vs-table-legend-icon visa-icon ' + iconClass}
              id={$this.tableId + iconMap[iconItem.iconName?.split('#')[1]].id}
              aria-label={iconItem.iconDescription}
              role="img"
            ></span>
            <span class="vs-text vs-legend-icon-desc" aria-hidden="true">
              {iconItem.iconDescription}
            </span>
          </span>
        );
      })}
    </p>,
  ];
};

export const tableTopContent = $this => {
  return (
    <div class="vs-header-text-wrapper">
      {!!$this.iconLegend.length && !!$this.iconKeyText.length && renderIconLegend($this, $this.stateObject.iconLegendList)}
      {$this.exportTable && renderTableExportButton($this)}
    </div>
  );
};

export const getColWidth = $this => {
  let colWidthSum = 0;
  let unsetCols = 0;
  let setColWidth = [];
  [...$this.stateObject.columnDataList].forEach(column => {
    if (column.columnWidthPercentage.length) {
      colWidthSum += parseInt(column.columnWidthPercentage);
      setColWidth.push(parseInt(column.columnWidthPercentage));
    } else {
      unsetCols += 1;
      setColWidth.push('rem');
    }
  });
  if (colWidthSum != 100) {
    setColWidth = setColWidth.map(item => (item === 'rem' ? (100 - colWidthSum) / unsetCols : item));
  }
  $this.stateObject.colWidthList = setColWidth;
};

export const onResize = $this => {
  $this.tableWidth = document.getElementById($this.tableId)?.offsetWidth;
  const scrollbarWrapperWidth = document.getElementById('vs-scroll' + $this.tableId)?.offsetWidth;
  $this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  $this.stateObject.scrollbarWidth = Math.abs($this.tableWidth - scrollbarWrapperWidth) + 30;
  $this.stateObject.scrollbarThumbWidth = $this.screenWidth / $this.stateObject.columnDataList.length;
  $this.el.style.setProperty('--scrollbar-thumb-width', `${$this.stateObject.scrollbarThumbWidth}px`);
  $this.stateObject.scrollValue = $this.tableRef.scrollLeft;
};

export const formatTableBody = $this => {
  const finalData = [];
  $this.parsedRowData.forEach(elementArr => {
    const map = {};
    elementArr.forEach((row, i: number) => {
      map[i] = row.cellData;
    });
    finalData.push(map);
  });

  $this.stateObject.originalRowData = finalData;
  if ($this.sortColumn >= 0 && $this.hasCellMerges === false) {
    const sortedData = handleSort($this, $this.stateObject.columnDataList[$this.sortColumn], $this.sortColumn, true);
    return sortedData;
  }
  return finalData;
};

export const applyAriaSort = ($this, colIndex, sortDir) => {
  let previousSortedCol;
  let newSortedCol;

  previousSortedCol = $this.el.querySelector(`table thead th:nth-child(${$this.previousSortIndex + 1})`);

  // START GENAI@GHCOPILOT
  // write code to get nth <th> in <thead> in the table
  newSortedCol = $this.el.querySelector(`table thead th:nth-child(${colIndex + 1})`);
  // END GENAI@GHCOPILOT

  if ($this.previousSortIndex > -1) {
    previousSortedCol?.removeAttribute('aria-sort');
  }

  if (newSortedCol?.getAttribute(`data-col-sortable`) === 'yes') {
    setAriaSort(sortDir, newSortedCol);
  }

  $this.previousSortIndex = colIndex;
};

export const setAriaSort = (sortDir, colHead) => {
  if (sortDir === 'asc') {
    colHead.setAttribute('aria-sort', 'ascending');
  } else {
    colHead.setAttribute('aria-sort', 'descending');
  }
};

export const applyCellA11y = ($this, row, col) => {
  const prevFocussedRow = $this.previousFocusedCellPos[0];
  const prevFocussedCol = $this.previousFocusedCellPos[1];

  // START GENAI@GHCOPILOT
  const prevFocusedCell = $this.tablea11yArray[prevFocussedRow][prevFocussedCol];
  const currentFocusedCell = $this.tablea11yArray[row][col];
  // END GENAI@GHCOPILOT

  if (prevFocusedCell) {
    prevFocusedCell.setAttribute('tabindex', '-1');
  }
  currentFocusedCell.focus();
  currentFocusedCell.setAttribute('tabindex', '0');
  currentFocusedCell.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  $this.previousFocusedCellPos = [row, col];
  setLinkA11y(currentFocusedCell);
};

export const handleMouseDown = $this => {
  $this.usingKeyboard = false;
  restoreAllLinkA11y($this);
};

export const handleKeyDown = ($this, event) => {
  if (event.target.tagName === 'TD' || event.target.tagName === 'TH' || document.activeElement.tagName === 'A') {
    const prevRow = $this.previousFocusedCellPos[0];
    const prevCol = $this.previousFocusedCellPos[1];
    let currentRow = prevRow;
    let currentCol = prevCol;

    removeAllLinkA11y($this);
    setLinkA11y($this.tablea11yArray[currentRow][currentCol]);

    // START GENAI@GHCOPILOT
    switch (event.key) {
      case 'Tab':
        if (document.activeElement.tagName !== 'A') {
          handleTabPress($this, event.target.tagName);
          break;
        } else {
          return;
        }

      case 'ArrowRight':
        if (prevCol < $this.stateObject.tableSize[1]) {
          currentCol = prevCol + 1;
        }
        break;
      case 'ArrowLeft':
        if (prevCol > 0) {
          currentCol = prevCol - 1;
        }
        break;
      case 'ArrowDown':
        if (prevRow < $this.stateObject.tableSize[0]) {
          currentRow = prevRow + 1;
        }
        break;
      case 'ArrowUp':
        if (prevRow > 0) {
          currentRow = prevRow - 1;
        }
        break;
      // END GENAI@GHCOPILOT
      case 'Home':
        handleHomePress($this, event, currentRow);
        break;
      case 'End':
        handleEndPress($this, event, currentCol);
        break;
      case 'PageDown':
        if (prevRow + 5 < $this.stateObject.tableSize[0]) {
          currentRow = prevRow + 5;
        }
        break;
      case 'PageUp':
        if (prevRow - 5 > 1) {
          currentRow = prevRow - 5;
        }
        break;
      default:
        break;
    }
    applyCellA11y($this, currentRow, currentCol);
  }
};

export const handleFocus = ($this, event) => {
  if ($this.usingKeyboard) {
    event.target.classList.add('vs-keyboard-focused');
  }
};

export const handleBlur = event => {
  if (event.target.tagName === 'TD' || event.target.tagName === 'TH') {
    event.target.classList.remove('vs-keyboard-focused');
  }
};

export const handleTabPress = ($this, tagname) => {
  if (tagname !== 'A') {
    const prevFocussedRow = $this.previousFocusedCellPos[0];
    const prevFocussedCol = $this.previousFocusedCellPos[1];
    if (prevFocussedRow > 1 && $this.previousFocusedCellPos[1] > 1) {
      let current = $this.tablea11yArray[prevFocussedRow][prevFocussedCol];
      current.setAttribute('tabindex', '-1');
    } else {
      applyCellA11y($this, 0, 0);
      $this.tableRef.querySelector(`th, td`).setAttribute('tabindex', '-1');
      $this.tableRef.querySelector(`th, td`).classList.add('vs-keyboard-focused');
    }
  }
};

export const handleHomePress = ($this, event, prevRow) => {
  if (event.ctrlKey) {
    applyCellA11y($this, 0, 0);
  } else {
    applyCellA11y($this, prevRow, 0);
  }
};

export const handleEndPress = ($this, event, prevCol) => {
  if (event.ctrlKey) {
    applyCellA11y($this, $this.stateObject.tableSize[0] - 1, $this.stateObject.tableSize[1] - 1);
  } else {
    applyCellA11y($this, prevCol, $this.stateObject.tableSize[1] - 1);
  }
};

export const setDataSortAttribute = (colType: string, sortable: boolean) => {
  if (sortable) {
    let sortInfo = 'sortBy: ';
    // START GENAI@GHCOPILOT
    switch (colType) {
      case 'textField':
        sortInfo += 'text';
        break;
      case 'iconField':
        sortInfo += 'icon';
        break;
      case 'dateField':
        sortInfo += 'date';
        break;
      default:
        sortInfo += '';
    }
    return { 'data-sort-info': sortInfo };
    // END GENAI@GHCOPILOT
  }
};

// START GENAI@CHATGPT4
export const getTableA11yArray = $this => {
  const tableElement = document.getElementById($this.tableId) as HTMLTableElement;
  const tableArray = [];

  for (let rowIndex = 0; rowIndex < tableElement.rows.length; rowIndex++) {
      tableArray[rowIndex] = [];
  }

  for (let rowIndex = 0; rowIndex < tableElement.rows.length; rowIndex++) {
      const tableRow = tableElement.rows[rowIndex];
      for (let cellIndex = 0; cellIndex < tableRow.cells.length; cellIndex++) {
          const tableCell = tableRow.cells[cellIndex];

          const cellRowSpan = tableCell.rowSpan || 1;
          const cellColSpan = tableCell.colSpan || 1;

          let currentRowIndex = rowIndex;
          let currentCellIndex = cellIndex;
          while (tableArray[currentRowIndex][currentCellIndex]) {
              currentCellIndex++;
          }

          for (let rowSpanIndex = 0; rowSpanIndex < cellRowSpan; rowSpanIndex++) {
              for (let colSpanIndex = 0; colSpanIndex < cellColSpan; colSpanIndex++) {
                  tableArray[currentRowIndex + rowSpanIndex][currentCellIndex + colSpanIndex] = tableCell;
              }
          }
      }
  }

  return tableArray;
}
// END GENAI@CHATGPT4

// START GENAI@GHCOPILOT
export const removeAllLinkA11y = $this => {
  const table = $this.tableRef;
  const tableRows = table.querySelectorAll('tr');
  tableRows.forEach(row => {
    const rowCells = row.querySelectorAll('th, td');
    rowCells.forEach(cell => {
      const links = cell.querySelectorAll('a');
      links?.forEach(anchor => {
        anchor.setAttribute('tabindex', '-1');
      });
    });
  });
};
// END GENAI@GHCOPILOT

export const setLinkA11y = tableCell => {
  const links = tableCell.querySelectorAll('a');
  links?.forEach(anchor => {
    anchor.removeAttribute('tabindex');
    anchor.removeAttribute('aria-hidden');
  });
};

// START GENAI@GHCOPILOT
export const restoreAllLinkA11y = $this => {
  const table = $this.tableRef;
  const tableRows = table.querySelectorAll('tr');
  tableRows.forEach(row => {
    const rowCells = row.querySelectorAll('th, td');
    rowCells.forEach(cell => {
      const links = cell.querySelectorAll('a');
      links?.forEach(anchor => {
        anchor.removeAttribute('tabindex');
      });
    });
  });
};

function renderTableBodyContent($this: any) {
  return $this.rowDataList.map((row, ind) => {
    return (
      <tr>
        {Object.keys(row).map((index, cellIndex) => {
          const isFirstCellInFirstRow = ind === 0 && cellIndex === 0; // Check if it's the first cell in the first row
          return !row[index].richText && !row[index].formattedDate && !row[index].imgPath && !row[index].iconName ? (
            <td
              class={$this.parsedRowData[ind][index]?.cellData.backgroundColor}
              id={$this.tableId + $this.parsedRowData[ind][index]?.cellData.id}
              rowSpan={$this.parsedRowData[ind][index]?.cellData.rowSpan}
              colSpan={$this.parsedRowData[ind][index]?.cellData.colSpan}
              tabindex="-1"
            >
              <span class="vs-sr-only">{$this.blankCellScreenReader}</span>
            </td>
          ) : isFirstCellInFirstRow ? ( // Explicitly set scope="col" for the first cell in the first row
            <th
              scope="col"
              class={$this.parsedRowData[ind][index]?.cellData.backgroundColor}
              id={$this.tableId + $this.parsedRowData[ind][index]?.cellData.id}
              rowSpan={$this.parsedRowData[ind][index]?.cellData.rowSpan}
              colSpan={$this.parsedRowData[ind][index]?.cellData.colSpan}
              tabindex="-1"
              {...formatHeaderIds($this, $this.parsedRowData[ind][index]?.cellData.headers)}
            >
              {setCellData(row[index], $this)}
            </th>
          ) : $this.parsedRowData[ind][index]?.cellData.rowHeader === 'true' || $this.stateObject.columnDataList[index].isRowHeader === 'true' ? (
            renderHeaderCell($this, row, index, ind)
          ) : (
            <td
              class={$this.parsedRowData[ind][index]?.cellData.backgroundColor}
              id={$this.tableId + $this.parsedRowData[ind][index]?.cellData.id}
              rowSpan={$this.parsedRowData[ind][index]?.cellData.rowSpan}
              colSpan={$this.parsedRowData[ind][index]?.cellData.colSpan}
              {...formatHeaderIds($this, $this.parsedRowData[ind][index]?.cellData.headers)}
              tabindex="-1"
            >
              {setCellData(row[index], $this)}
            </td>
          );
        })}
      </tr>
    );
  });
}

// START GENAI@CHATGPT4
export const formatHeaderIds = ($this, headerText) => {
  if ($this.isMultiLevelTable && headerText && headerText.trim().length > 0 && headerText.trim() !== ',') {
    return {
      headers:
        headerText
          ?.split(',')
          .map(header => `${$this?.tableId}${header.trim()}`)
          .join(' ') || '',
    };
  } else {
    return {};
  }
};
// END GENAI@CHATGPT4

export const renderHeaderCell = ($this, row, index, ind) => {
  if ($this.stateObject.columnDataList[index].isRowHeader  === 'true') {
    return (
      <th
        scope={
          $this.parsedRowData[ind][index]?.cellData.colSpan > 1
            ? setHeaderScope($this.parsedRowData[ind][index]?.cellData.rowSpan, $this.parsedRowData[ind][index]?.cellData.colSpan)
            : $this.parsedRowData[ind][index]?.cellData.colSpan > 1
            ? 'rowgroup'
            : 'row'
        }
        tabindex="-1"
        class={$this.parsedRowData[ind][index]?.cellData.backgroundColor}
        id={$this.tableId + $this.parsedRowData[ind][index]?.cellData.id}
        rowSpan={$this.parsedRowData[ind][index]?.cellData.rowSpan}
        colSpan={$this.parsedRowData[ind][index]?.cellData.colSpan}
        /* START GENAI@CHATGPT4 */
        {...formatHeaderIds($this, $this.parsedRowData[ind][index]?.cellData.headers)}
        /* END GENAI@CHATGPT4 */
      >
        {setCellData(row[index], $this)}
      </th>
    );
  }
  return (
    <th
        scope={setHeaderScope($this.parsedRowData[ind][index]?.cellData.rowSpan, $this.parsedRowData[ind][index]?.cellData.colSpan)}
        tabindex="-1"
        class={$this.parsedRowData[ind][index]?.cellData.backgroundColor}
        id={$this.tableId + $this.parsedRowData[ind][index]?.cellData.id}
        rowSpan={$this.parsedRowData[ind][index]?.cellData.rowSpan}
        colSpan={$this.parsedRowData[ind][index]?.cellData.colSpan}
        /* START GENAI@CHATGPT4 */
        {...formatHeaderIds($this, $this.parsedRowData[ind][index]?.cellData.headers)}
        /* END GENAI@CHATGPT4 */
      >
        {setCellData(row[index], $this)}
      </th>
  );
};

// END GENAI@GHCOPILOT


// START GENAI@GHCOPILOT
export const setHeaderScope = (rowspan, colspan) => {
  let scope = '';
  if (rowspan === 1 && colspan === 1) {
    scope = 'col';
    return scope;
  }
  if (rowspan > 1 ) {
    scope += 'rowgroup ';
  } 
  if (colspan > 1) {
    scope += 'colgroup';
  }
  return scope;
}
// END GENAI@GHCOPILOT

// START GENAI@CHATGPT4
export const hasMultipleRowsWithColspanGreaterOneAndIsRowHeader = (rowData: any[]) => {
  let count = 0;
  rowData.forEach(row => {
      const hasRowspanGreaterOneAndIsRowHeader = row.some((cell: any) => cell.cellData.colSpan > 1 && cell.cellData.rowHeader === "true");
      if (hasRowspanGreaterOneAndIsRowHeader) {
          count += 1;
      }
  });
  return count > 1 ? true : false;
}
// END GENAI@CHATGPT4
